module.exports = __webpack_public_path__ + "2bb9dd5795160c31faf271a6a2bd171c.woff2";